/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Break_DoubleInputs */



/**
* | output |
* | --- |
* | "Blank line after" |
*
* @param {Transcript_Export_Break_DoubleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_break_double = /** @type {((inputs?: Transcript_Export_Break_DoubleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Break_DoubleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Blank line after")
	if (locale === "de") return /** @type {LocalizedString} */ ("Blank line after")
	if (locale === "it") return /** @type {LocalizedString} */ ("Blank line after")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Blank line after")
	if (locale === "es") return /** @type {LocalizedString} */ ("Blank line after")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Blank line after")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Blank line after")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Blank line after")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Blank line after")
	return /** @type {LocalizedString} */ ("Blank line after")
});